import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import ConnectorScreen from './ConnectorScreen';
import ConnectorView from './ConnectorView';
import ConnectorViewSalesforceNew from './ConnectorViewSalesforceNew.vue';

const {routes} = router.options;
const route = routes.find(r => r.path === '/app');

const tmpRoutes = [
  {
    path: 'connector-screen',
    name: 'connectorScreen',
    component: ConnectorScreen,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'connector-screen/:configurationId',
    name: 'connector',
    component: ConnectorView,
  },
  {
    path: 'connector-screen/:configurationId/dynamo',
    name: 'dynamo-connector',
    component: () => import('@/modules/ConnectorScreen/ConnectorViewNew.vue') ,
  },
  {
    path: 'connector-screen/salesforce-new/:configurationId',
    name: 'connector-salesforce-new',
    component: ConnectorViewSalesforceNew,
  },
];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('connector-screen', {
//   path: '/app/connector-screen',
//   text: 'Connectors',
//   uuid: 'Connector Screen',
//   permission: 'write',
//   weight: 0,
//   icon: ['fas', 'cogs']
// }));
